export default "__VITE_ASSET__C6xfhAK7__"